import { useRef, useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

// Careers — a Google Form in the DAAS Global account. It has a CV upload, so Google asks applicants to sign in;
// Google sign-in does not work inside an embedded frame, so the form opens in a new tab.
const CAREERS_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSe2KcnoZjoxPXAMpJ7okMmTnTbiDave7Wfl6LG3_U6NIea6Eg/viewform';

const CareerApplicationForm = ({ isOpen, onClose }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-modal-overlay"
      onClick={(e) => { if (e.target === overlayRef.current) onClose(); }}
      data-testid="career-form-overlay"
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        className="relative bg-white w-full max-w-lg animate-modal-slide-up"
        data-testid="career-form-modal"
      >
        {/* Header */}
        <div className="px-8 pt-8 pb-4 border-b border-[var(--border)]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[var(--secondary)] text-xs font-bold uppercase tracking-[0.2em] mb-1">Careers</p>
              <h2 className="text-2xl font-bold text-[var(--primary)] tracking-tight">Drop Your Resume</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-[var(--background)] transition-colors" data-testid="career-form-close">
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="p-8 space-y-6" data-testid="career-application-form">
          <p className="text-[var(--text-secondary)]">
            Interested in working with DAAS Global? Leave your details and CV in our application form, and we will reach out if there is a suitable opportunity.
          </p>
          <p className="text-[var(--text-secondary)] text-sm">
            The form opens in a new tab. Google asks you to sign in to upload your CV (up to 10 MB).
          </p>
          <a
            href={CAREERS_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="btn-primary w-full inline-flex items-center justify-center gap-2"
            data-testid="career-form-open"
          >
            Open the Application Form <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CareerApplicationForm;
